export enum EmailInsightReviewStatus {
  Pending = 'pending',
  Confirmed = 'confirmed',
  Discarded = 'discarded',
}
